module.exports = __webpack_public_path__ + "img/feature3.dbc8f099.png";